import { ColDef } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { billingCostColumnDef } from "../common/billingCostColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { forecastedEOMColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/forecastedEOMColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const azVmssColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Instance Name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_vmss"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  { field: "resource.resource_group", headerName: "Resource Group" },

  { field: "resource.instances_count", headerName: "Instances" },

  { field: "resource.desired_capacity", headerName: "Default Instances" },

  { field: "resource.orchestration_mode", headerName: "Orchestration Type" },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
